import styled from 'styled-components';
import { Col, Row } from '@vds/grids';

// import { screenTypes } from '../../common/Helpers/screenTypes';

export const TopNav = styled.div`
  position: fixed;
  bottom: 0;
  z-index: 999;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
`;

export const StickyCartWrap = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 999;
  width: 100%;
  background-color: #fff;
  padding: 6px 16px 12px 16px;
  box-shadow: 6px -8px 16px 0px #0000001a;
`;

export const PriceWrap = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  align-self: stretch;
`;

export const DueContianer = styled.div`
  display: flex;
  padding: 4px 12px;
  align-items: center;
  gap: 16px;
  align-self: stretch;
  border-radius: 8px;
  background: #f6f6f6;
`;

export const PriceContianer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
`;

export const StrokeDiv = styled.div`
  border: 1px solid #d8dada;
  height: 24px;
`;

export const MiniCartItem = styled.div`
  display: flex;
  padding: 4px 12px;
  align-items: center;
  gap: 16px;
  align-self: stretch;
`;

export const ButtonCol = styled(Col)`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const PriceCol = styled(Col)``;

export const RowContainer = styled(Row)`
  justify-content: space-evenly;
  width: max-content;
`;

export const ReviewPriceContainer = styled.div`
  padding: 24px 16px 16px 16px;
  border-radius: 12px;
  border: 1px solid #a7a7a7;
`;
